import request from '@/utils/request'

// 获取用户信息
export function getUserInfo() {
    return request({
      url: '/api/users',
      method: 'get',
    })
}

// 修改用户信息
export function updateUserInfo(data) {
    return request({
        url: '/api/users',
		method: 'put',
		data
    })
}


// 意见反馈-历史
export function getHistoryFeedback(params) {
	return request({
		url: '/api/feedback',
		method: 'get',
		params
	})
}

// 意见反馈-提交
export function addFeedback(data) {
	return request({
		url: '/api/feedback',
		method: 'post',
		data
	})
}